import GPN from "google-libphonenumber";
import * as Yup from "yup";

const phoneUtil = GPN.PhoneNumberUtil.getInstance();

declare module "yup" {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  export interface StringSchema {
    /**
     * Check for phone number validity.
     *
     * @param {String} [countryCode=IN] The country code to check against.
     * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
     */
    phone(countryCode?: string, errorMessage?: string): StringSchema;
  }
}

const YUP_PHONE_METHOD = "phone";
export type TCountryCode = "LT" | "DE" | "GB" | "DK" | "NO" | "IE" | "NL" | "SE" | "ES";

Yup.addMethod(
  Yup.string,
  YUP_PHONE_METHOD,
  function yupPhone(countryCode: TCountryCode = "LT", errorMessage: string = "") {
    // eslint-disable-next-line no-template-curly-in-string
    const errMsg = errorMessage ? errorMessage : "${path} must be a valid phone number.";
    return this.test(YUP_PHONE_METHOD, errMsg, (value?: string) => {
      try {
        const phoneNumber = phoneUtil.parse(`+${value}`, countryCode); //need to add "+" prefix to value https://github.com/ruimarinho/google-libphonenumber/issues/348
        return phoneUtil.isValidNumberForRegion(phoneNumber, countryCode);
      } catch {
        return false;
      }
    });
  }
);
